<template>
  <section class="index" :class="{ active: isIndexActive }">
    <button class="index__btn open" @click="$emit('openIndex')">
      <img src="@/assets/hamburger.svg" alt="開啟" />
    </button>

    <div class="index__curtain">
      <div ref="indexContainer" class="index-container">
        <button class="index__btn close" @click="$emit('closeIndex')">
          <img src="@/assets/close.svg" alt="關閉" />
        </button>

        <div class="index-list">
          <ul>
            <li>
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-royalsalute/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                吳書原 X 皇家禮炮
              </a>
            </li>
            <li>
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-legend/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                胡毓偉 X 歲末選酒
              </a>
            </li>
            <li>
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-glenlivet/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                許含光 X 格蘭利威
              </a>
            </li>
            <li>
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-glenmorangie/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                王心偉 X 格蘭傑
              </a>
            </li>
            <li>
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-jw/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                曾孟卓 X JOHNNIE WALKER
              </a>
            </li>
            <li class="active">
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-singleton/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                洪璽開 X 蘇格登
              </a>
            </li>
            <li>
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-spey/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                黃清毅 X SPEY
              </a>
            </li>
            <li>
              <a
                href="https://www.mirrormedia.mg/campaigns/whisky2021-yushan/index.html"
                target="_self"
                @click="$emit('closeIndex')"
              >
                林敬堯 X 玉山高粱
              </a>
            </li>
          </ul>
        </div>

        <div class="share">
          <p>分享到：</p>
          <UiShareFacebook />
          <UiShareLine />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

import { brand } from '../../content'

import UiShareFacebook from './UiShareFacebook.vue'
import UiShareLine from './UiShareLine.vue'

export default {
  name: 'UiArticleIndex',

  components: {
    UiShareFacebook,
    UiShareLine
  },

  props: {
    isIndexActive: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      url: `https://www.mirrormedia.mg/campaigns/whisky2021-${brand}/index.html`,
      smoothScroll: undefined,
    }
  },

  watch: {
    isIndexActive(isActive) {
      isActive
        ? disableBodyScroll(this.$refs.indexContainer)
        : enableBodyScroll(this.$refs.indexContainer)
    },
  },
}
</script>

<style lang="scss" scoped>
.index {
  @media screen and (min-width: 1200px) {
    position: static;
  }

  &.active .index__curtain {
    display: block;
  }

  &__btn {
    display: flex;
    justify-content: center;
    align-items: center;
    top: 12.5px;
    right: 10px;
    width: 35px;
    height: 35px;
    background-color: transparent;
    border: 1px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    user-select: none;
    outline: none;
    @media screen and (min-width: 1200px) {
      display: none;
    }

    &.open {
      position: fixed;
      z-index: 999;
    }

    &.close {
      position: absolute;
      background-color: #000;
    }
  }

  &__curtain {
    display: none;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background-color: rgba(#000, 0.8);
    @media screen and (min-width: 1200px) {
      display: inline-block;
      position: absolute;
      top: 0;
      left: calc((-100vw + 700px) / 2 + 80px);
      right: auto;
      bottom: auto;
      z-index: 300;
      background-color: transparent;
      width: auto;
      height: auto;
    }
  }

  &-container {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    top: 0;
    right: 0;
    width: auto;
    height: 100%;
    padding: 0 12px;
    background-color: #fff;
    @media screen and (min-width: 1200px) {
      position: static;
      padding: 0;
      background-color: transparent;
    }
  }
}

.index-list {
  display: inline-block;

  + * {
    margin-top: 48px;
  }

  ul {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    width: 190px;
    margin: 0;
    padding: 0;
    @media screen and (min-width: 1200px) {
      width: 240px;
    }

    li {
      display: inline;
      font-size: 14px;
      line-height: 19px;
      cursor: pointer;

      &.active a {
        border-bottom: solid 2px #dec5a2;
      }

      + li {
        margin-top: 19px;
      }
    }
  }
}

.share {
  display: flex;
  align-items: center;
  font-size: 15px;

  p + a {
    margin-left: 18px;
  }

  a {
    width: 36px;

    + a {
      margin-left: 17px;
    }
  }
}
</style>
